// extracted by mini-css-extract-plugin
module.exports = {"rotate":"Header_rotate__MAFku","rotation":"Header_rotation__kRr8r"};